// 通用的待审批 页面 配置
import CommenApproval from "./commonApproval.js";
export default {
  ...CommenApproval
  // leaveOffice: {
  //   component: Leave, // 组件名称
  //   serviceUrl: "/treasure/ehr/leaveOffice/DoProcessInstance", // 申请详情的接口
  //   recordUrl: "/treasure/ehr/leaveOffice/DoProcessInstance", // 审批记录的接口
  //   method: "post",  // 接口的方法
  //   recordKey: "qh_hr_011_sta", // 执行我的申请取消操作的时候 从数据的哪个字段里取值
  //   data: [["instance_id", "instanceId"]],  //请求接口参数 【0】是 key 【1】 是value值
  //   title: "离职申请详情" // title
  // },
};
